import { Injectable, ErrorHandler } from '@angular/core';

import * as Sentry from '@sentry/browser';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  handleError(error) {
    Sentry.captureException((error.originalError ?? '') !== '' || error);
    throw error;
  }
}
